import { api } from '../api/client'
import type { Role } from '../api/types'
import { canEdit } from './projects'
import { sharedRead } from './reads'
import { useAsync } from './useAsync'

/** Whether a viewer manages any project (its Editor or Admin), so the
 *  Alerts tab shows for them: they set rules on its stations. Platform
 *  admins always see it; nobody else is asked. */
export function useManagesProjects(role: Role | null | undefined): boolean {
  const list = useAsync(
    () => (role === 'viewer' ? sharedRead('projects', () => api.projects.list()) : Promise.resolve(undefined)), [role])
  return (list.data?.projects ?? []).some((p) => canEdit(p.my_role))
}
